module.exports = __webpack_public_path__ + "static/media/sync.45c25a4d.svg";